import { render } from "./Group3DViewerListPage.vue?vue&type=template&id=10c3e81c&scoped=true&ts=true"
import script from "./Group3DViewerListPage.vue?vue&type=script&lang=ts"
export * from "./Group3DViewerListPage.vue?vue&type=script&lang=ts"

import "./Group3DViewerListPage.vue?vue&type=style&index=0&id=10c3e81c&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10c3e81c"]])

export default __exports__